export { seoApi as api } from './api';
export * as types from './types';
